// pages/SaisieJoursPris.jsx
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Save, RefreshCw, CheckCircle, AlertCircle } from 'lucide-react';

export default function SaisieJoursPris() {
  const [employes, setEmployes] = useState([]);
  const [joursSaisis, setJoursSaisis] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const anneeCourante = new Date().getFullYear();

  useEffect(() => { fetchEmployes(); }, []);

  const fetchEmployes = async () => {
    setLoading(true);
    try {
      const res = await api.get('/employes');
      setEmployes(res.data.employes || []);
    } catch (err) {
      setMessage({ type: 'error', text: 'Erreur chargement' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (employeId, value) => {
    setJoursSaisis(prev => ({
      ...prev,
      [employeId]: parseFloat(value) || 0
    }));
  };

  const saveAll = async () => {
    setSaving(true);
    let success = 0, errors = 0;

    for (const emp of employes) {
      const jours = joursSaisis[emp.ID_Employes] || 0;
      if (jours === 0) continue;

      try {
        await api.put(`/soldes/update-pris/${emp.ID_Employes}`, { JoursPris: jours });
        success++;
      } catch (err) {
        errors++;
      }
    }

    setMessage({
      type: success > 0 ? 'success' : 'error',
      text: `${success} enregistrés, ${errors} erreurs`
    });

    if (success > 0) setJoursSaisis({});
    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    setSaving(false);
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">📅 Congés déjà pris</h2>
          <p className="text-sm text-gray-500 mt-1">
            Saisie rétroactive des jours pris du 01/01/{anneeCourante} au 31/05/{anneeCourante}
          </p>
        </div>
        <div className="flex gap-2">
          <button onClick={fetchEmployes} className="p-2 text-gray-500 hover:text-purple-600 transition">
            <RefreshCw size={18} />
          </button>
          <button onClick={saveAll} disabled={saving || loading}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg text-sm flex items-center gap-2 hover:bg-purple-700 transition disabled:opacity-50">
            <Save size={16} /> Enregistrer
          </button>
        </div>
      </div>

      {message.text && (
        <div className={`mb-4 p-3 rounded-lg flex items-center gap-2 ${
          message.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
        }`}>
          {message.type === 'success' ? <CheckCircle size={16} /> : <AlertCircle size={16} />}
          {message.text}
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr className="text-xs text-gray-500">
              <th className="px-4 py-3 text-left">Employé</th>
              <th className="px-4 py-3 text-center w-48">Jours déjà pris en {anneeCourante}</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {loading ? (
              <tr><td colSpan="2" className="px-4 py-12 text-center text-gray-400">Chargement...</td></tr>
            ) : employes.length === 0 ? (
              <tr><td colSpan="2" className="px-4 py-12 text-center text-gray-400">Aucun employé</td></tr>
            ) : (
              employes.map(emp => (
                <tr key={emp.ID_Employes} className="hover:bg-gray-50">
                  <td className="px-4 py-3">
                    <span className="font-medium">{emp.Prenom} {emp.Nom}</span>
                    <span className="text-xs text-gray-400 ml-2">{emp.Matricule}</span>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <input type="number" step="0.5" min="0"
                      className="w-28 p-2 border rounded-lg text-center focus:ring-2 focus:ring-purple-500"
                      value={joursSaisis[emp.ID_Employes] || ''}
                      onChange={(e) => handleChange(emp.ID_Employes, e.target.value)}
                      placeholder="0" />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}